import React from "react";

/**
 * App-style bottom navigation bar. Each role passes its own `tabs`.
 * tab: { id, label, icon (Phosphor component), testId, badge? }
 */
export function BottomNav({ tabs, active, onChange }) {
  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      {tabs.map((t) => {
        const Icon = t.icon;
        const isActive = active === t.id;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            className={`bottom-nav-item ${isActive ? "is-active" : ""}`}
            data-testid={t.testId}
            aria-current={isActive ? "page" : undefined}
          >
            <span className="bottom-nav-icon">
              <Icon size={24} weight={isActive ? "fill" : "regular"} />
              {t.badge ? <span className="bottom-nav-badge" data-testid={`${t.testId}-badge`} /> : null}
            </span>
            <span className="bottom-nav-label">{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
